/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import Layout from '../../components/BridgePage/Layout'
import './index.scss'

const AboutCg = () => (
  <Layout>
    <div className='aboutCg'>
      <h1 className='CgTitle'>Community Guidelines</h1>

      <h2>I. Special Notice</h2>
      <p>
        Your access to and use of Yaaro's services are governed by the Yaaro Terms of Service, along with any other policies or guidelines published by Yaaro from time to time. Yaaro will notify you of any changes to these Community Guidelines. Revised guidelines become effective immediately upon posting, superseding all prior versions.
      </p>
      <p>
        You understand and agree that you bear full responsibility for any content you create, stream, post, upload, publish, transmit, or otherwise make available through the Yaaro platform. This responsibility includes ensuring that your content is lawful, reliable, accurate, and appropriate.
      </p>
      <p>
        Yaaro also reserves the right, as part of its operational decisions, to terminate or suspend your access to its services or to modify the services provided.
      </p>
      <p>
        You agree not to directly or indirectly violate these Community Guidelines or any applicable laws, regulations, and public order requirements. This includes compliance with, but is not limited to, the legal standards of the regions where Yaaro operates and where your content is made accessible.
      </p>

      <h2>II. Prohibited Conduct and Content</h2>
      <p>
        To foster a positive environment for all users, Yaaro strictly prohibits the following types of behaviour and content:
      </p>

      <h3>Violence and Criminal Activity</h3>
      <ul>
        <li>Content that depicts, encourages, or provides instructions for unlawful acts, dangerous behaviour, or self-harm.</li>
        <li>Content that contains threats of any kind, including physical violence, harassment, trolling, or bullying.</li>
        <li>Promotion of terrorism, extremism, or any related activities.</li>
        <li>Defamatory, obscene, offensive, hateful, or inflammatory material.</li>
        <li>Content that endorses or promotes cruelty to animals, vandalism, property destruction, or poaching of endangered species.</li>
      </ul>

      <h3>Controlled or Illegal Items</h3>
      <ul>
        <li>Content describing the production, trade, or use of illegal drugs or controlled substances.</li>
        <li>Facilitating the exchange or sale of firearms, ammunition, explosives, or weapon components.</li>
        <li>Coordinating or supporting the poaching of or trade in endangered species.</li>
        <li>Any content involving contraband as defined by applicable local laws.</li>
      </ul>

      <h3>Violation of Others' Rights or Platform Integrity</h3>
      <ul>
        <li>Uploading files containing malicious code such as viruses, trojans, or worms.</li>
        <li>Sharing third-party private information (e.g., addresses, phone numbers, ID numbers) without explicit consent.</li>
        <li>Promoting competing platforms through text, voice, or images.</li>
        <li>Uploading content that infringes on intellectual property rights or violates privacy.</li>
      </ul>

      <h3>Sexually Explicit Material</h3>
      <ul>
        <li>Displaying or implying sexual acts, nudity, or other explicit behaviour.</li>
        <li>Sharing content with sexual innuendo, harassment, or unwelcome advances.</li>
      </ul>

      <h3>Discriminatory Content</h3>
      <ul>
        <li>Racist or discriminatory content targeting a person's race, religion, age, gender, disability, or sexual orientation is strictly forbidden.</li>
      </ul>

      <h3>Impersonation</h3>
      <ul>
        <li>Impersonating any individual or entity, including Yaaro officials, is strictly prohibited.</li>
        <li>Spreading false information while posing as an official staff member.</li>
        <li>Using a false identity to deceive, threaten, or harm others.</li>
      </ul>

      <h3>Commercial or Unauthorised Use</h3>
      <ul>
        <li>Sharing spam, advertisements, or unauthorised solicitations.</li>
        <li>Promoting unauthorised links for financial gain.</li>
      </ul>

      <h3>Violation of Laws and Ethical Standards</h3>
      <ul>
        <li>Content that contradicts the constitutional or legal provisions of applicable countries, promotes unethical behaviour, or violates public order is strictly forbidden.</li>
      </ul>

      <h3>Content Harmful to Minors</h3>
      <ul>
        <li>Sexualisation or fetishisation of minors.</li>
        <li>Sharing images, videos, or other content depicting child nudity.</li>
        <li>Content showing violence against children in any form.</li>
      </ul>

      <h3>Gambling Activities</h3>
      <ul>
        <li>Using Yaaro for gambling, including transactions involving in-app virtual currency, is prohibited.</li>
      </ul>

      <h3>Fraud and Illegal Transactions</h3>
      <ul>
        <li>Activities such as unauthorised selling of virtual items (e.g., diamonds), scams, or impersonating officials to defraud others are strictly forbidden.</li>
      </ul>

      <h2>III. Enforcement and Reporting</h2>
      <p>
        Yaaro staff actively monitor content to ensure compliance with these Community Guidelines. Users are strongly encouraged to report any behaviour that may violate the guidelines. Upon confirmation of a violation, Yaaro reserves the right to take one or more of the following actions:
      </p>
      <ul>
        <li>Remove inappropriate or non-compliant content.</li>
        <li>Suspend or terminate the responsible user accounts.</li>
        <li>Report incidents to relevant law enforcement or regulatory authorities as required by law.</li>
      </ul>

      <h2>IV. How to Report Violations</h2>
      <p>
        If you suspect any violation of these Community Guidelines, please report it through the following channel:
      </p>
      <p>
        Email: <a href="mailto:report@yaarolive.com">report@yaarolive.com</a>
      </p>
      <p>
        Please provide as much detail as possible (e.g., username, content description, timestamp) to help us investigate promptly.
      </p>
    </div>
  </Layout>
)

export default AboutCg
